import { useState, useEffect, useCallback } from "react";
import { trackPageView } from "../analytics/posthog";

function getPage() {
  const path = window.location.pathname;
  if (path === "/") return "home";
  if (path === "/onboarding") return "onboarding";
  if (path === "/signup") return "signup";
  if (path === "/login") return "login";
  if (path === "/verify-email") return "verify-email";
  if (path === "/welcome") return "welcome";
  if (path === "/admin") return "dashboard"; // redirect old URL
  return "dashboard";
}

export default function useRouter() {
  const [page, setPage] = useState(getPage);

  useEffect(() => {
    const onNav = () => {
      const newPage = getPage();
      setPage(newPage);
      trackPageView(newPage);
    };
    window.addEventListener("popstate", onNav);
    trackPageView(getPage());
    return () => window.removeEventListener("popstate", onNav);
  }, []);

  const navigate = useCallback((path) => {
    window.history.pushState(null, "", path);
    window.dispatchEvent(new PopStateEvent("popstate", { state: null }));
  }, []);

  return { page, navigate };
}
